// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PIVOT_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PIVOT_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      pivotColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: null
        },
        minItems: 1
      },
      valueColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'aggregationFunction',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'AVERAGE'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'COUNT'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'COUNT_NULLS'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MAX'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MEDIAN'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MIN'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'MODE'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: null
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'PRODUCT'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'STANDARD_DEVIATION'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'STANDARD_ERROR'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'SUM'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                aggregationFunction: {
                  kind: 'string',
                  required: true,
                  value: 'VARIANCE'
                },
                newColumnName: {
                  kind: 'string',
                  required: false
                },
                column: {
                  kind: 'columnReference',
                  required: true,
                  inputDataName: 'Input dataset',
                  validationOptions: {
                    allowedLeafTypes: [
                      LeafType.INTEGER,
                      LeafType.DECIMAL
                    ]
                  }
                }
              }
            }
          ]
        },
        minItems: 1
      },
      groupColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Input dataset',
          validationOptions: null
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
